import Vue from 'vue'
import store from '@/store'

Vue.directive('permissions', {
  inserted(el, binding) {
    const userPermissions = store?.state?.AppActiveUser?.permissions || []
    const { value, modifiers } = binding

    // If empty/null/undefined — allow always
    if (
      value === undefined ||
      value === null ||
      value === '' ||
      (Array.isArray(value) && value.length === 0)
    ) {
      return
    }

    // Normalize permissions to array
    let required = typeof value === 'string'
      ? value.split(',').map(p => p.trim()).filter(Boolean)
      : Array.isArray(value)
        ? value
        : []

    // Still empty after normalization? Allow always
    if (required.length === 0) {
      return
    }

    // Check logic: .all = every perm, default = any
    const hasPermission = modifiers.all
      ? required.every(p => userPermissions.includes(p))
      : required.some(p => userPermissions.includes(p))

    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
})
